module.exports = __webpack_public_path__ + "img/corchete-fondo-crema-13.682f17d0.svg";